import { isEmpty } from "lodash";
import React, { useEffect } from "react";
import { Provider } from "react-redux";
import {
	BrowserRouter,
	Navigate,
	Route,
	Routes,
	Outlet,
} from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
//  Auth Routes
// import {
// 	LoginRoute,
// 	PrivateRoute,
// 	PublicRoute,
// } from "./components/common/routes";
//	Components
// import Home from "./components/modules/home";
//	Public
import ForgotPassword from "./components/public/forgotPassword";
import Login from "./components/public/login";
import ResetPassword from "./components/public/resetPassword";
import { URL } from "./constants/URL";
//  Loader
import FullPageLoader from "./loaders/fullPageLoader";
import "./scss/styles.scss";
//  Redux-store
import { persistor, store } from "./store/store";
import CS from "./services/commonService";
import PageNotFound from "./components/modules/pageNotFound";
import Dashboard from "./components/modules/dashboard";
//  Master Management
import Categories from "./components/modules/categories/index";
//  CMS
import Coupons from "./components/modules/coupons/index";
import Cuisines from "./components/modules/cuisines/index";
//	Components
//	Common
//  Email Templates
import AddUpdateEmailTemplate from "./components/modules/emailTemplates/addUpdate";
import EmailTemplates from "./components/modules/emailTemplates/index";
//  FAQ Management
import FaqCategoryListing from "./components/modules/faqcategories/index";
import FAQs from "./components/modules/faqs/index";
//  Orders
import GiftOrderDetails from "./components/modules/giftOrders/giftOrderDetails";
import GiftOrders from "./components/modules/giftOrders/index";
import Header from "./components/modules/header";
//  Help
import HelpQueriesRestaurants from "./components/modules/helpQueriesRestaurants/index";
import HelpQueriesUsers from "./components/modules/helpQueriesUsers/index";
import HelpTopics from "./components/modules/helpTopics/index";
// import PageNotFound from "./components/modules/pageNotFound";
import PayoutsHistory from "./components/modules/payoutsHistory/index";
//	Admin profile
import Profile from "./components/modules/profile/profile";
//	Restaurants
import RestaurantDetails from "./components/modules/restaurants/details";
import Restaurants from "./components/modules/restaurants/index";
import UpdateRestaurant from "./components/modules/restaurants/AddUpdate";
import AddIntegration from "./components/modules/restaurants/AddintegrationDetails";
import ContactSettings from "./components/modules/settings/contact";
import GeneralSettings from "./components/modules/settings/general";
//	Settings
//import PaymentGatewaySettings from "./components/modules/settings/paymentGateway";
import Sidebar from "./components/modules/sideBar";
import Transactions from "./components/modules/transactions/index";
//  Payouts
import TransactionsDetails from "./components/modules/transactions/transactionsDetails";
//	Users
import UserDetails from "./components/modules/users/details";
import Users from "./components/modules/users/index";
import Promotions from "./components/modules/promotions";
import CreatePromotion from "./components/modules/promotions/createPromotion";
import SendPromotion from "./components/modules/promotions/SendPromotion";
import UpdateUser from "./components/modules/users/UpdateUser";
import ContentReports from "./components/modules/contentReporting";
import ReportDetails from "./components/modules/contentReporting/ReportDetails";
import ReportReasons from "./components/modules/contentReporting/ReportReasons";
import Moods from "./components/modules/moods";
import UnClaimedGiftsPayout from "./components/modules/payoutsHistory/unclaimGiftsPayout";
import PromoGifting from "./components/modules/PromoGifts";
import PromoGiftDetails from "./components/modules/PromoGifts/PromoGiftDetails";

const isAuthenticated = () => {
	const val = isEmpty(CS.getItem("token")) ? false : true;
	return val;
};

const MainHomeComponents = () => {
	return (
		<div className="container-scrollbar">
			<Header />
			<Sidebar />
			<div className="page-body-wrapper">
				<div className="main-panel">
					<div className="content-wrapper">
						<div className="main-content-area">
							<div className="overlay" />
							<div className="main-content-block">
								<Outlet />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const PrivateRoutes = () => {
	return isAuthenticated() ? (
		<MainHomeComponents />
	) : (
		<Navigate to={URL.login} />
	);
};

function App() {
	let Theme = "light";
	let resize = true;
	let sidebar = true;

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	}, [Theme, resize, sidebar]);

	return (
		<div className="dashboard-container">
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
					<BrowserRouter>
						<Routes>
							<Route path="/" element={<PrivateRoutes />}>
								<Route index element={<Dashboard />} />
								<Route path={URL.dashboard} element={<Dashboard />} />
								<Route path={URL.profile} element={<Profile />} />
								<Route path={URL.users} element={<Outlet />}>
									<Route index element={<Users />} />
									<Route path={URL.onboarderedUsers} element={<Outlet />}>
										<Route index element={<Users />} />
										<Route path={URL.userDetails} element={<UserDetails />} />
										<Route path={URL.updateUserSlug} element={<UpdateUser />} />
									</Route>
									<Route path={URL.pendingRegistration} element={<Users />} />
									<Route path={URL.guestUsers} element={<Users />} />
									<Route path={URL.referrals} element={<Users />} />
								</Route>
								<Route path={URL.restaurants} element={<Outlet />}>
									<Route index element={<Restaurants />} />
									<Route
										path={URL.restaurantDetails}
										element={<RestaurantDetails />}
									/>
									<Route
										path={URL.updateRestaurantSlug}
										element={<UpdateRestaurant />}
									/>
									<Route
										path={URL.addRestaurant}
										element={<UpdateRestaurant />}
									/>
									<Route
										path={URL.addIntegration}
										element={<AddIntegration editFlag={false} />}
									/>
									<Route
										path={URL.updateIntegration}
										element={<AddIntegration editFlag={true} />}
									/>
								</Route>
								<Route path={URL.giftOrders} element={<Outlet />}>
									<Route index element={<GiftOrders />} />
									<Route
										path={URL.giftOrderDetails}
										element={<GiftOrderDetails />}
									/>
									<Route path={URL.promoGifts} element={<PromoGifting />} />
									<Route
										path={URL.promoGiftDetails}
										element={<PromoGiftDetails />}
									/>
									<Route
										path={URL.promoGiftApprovalRequests}
										element={<PromoGifting />}
									/>
								</Route>
								<Route path={URL.transactions} element={<Outlet />}>
									<Route index element={<Transactions />} />
									<Route
										path={URL.transactionsDetails}
										element={<TransactionsDetails />}
									/>
								</Route>
								<Route path={URL.payoutsHistory} element={<Outlet />}>
									<Route index element={<PayoutsHistory />} />
								</Route>
								<Route
									path={URL.unClaimedGiftsPayout}
									element={<UnClaimedGiftsPayout />}
								/>
								<Route path={URL.contentReporting} element={<Outlet />}>
									<Route index element={<ContentReports />} />
									<Route
										path={URL.contentReportDetails}
										element={<ReportDetails />}
									/>
									<Route path={URL.reportReasons} element={<ReportReasons />} />
								</Route>
								<Route path={URL.emailTemplates} element={<Outlet />}>
									<Route index element={<EmailTemplates />} />
									<Route
										path={URL.updateEmailTemplate}
										element={<AddUpdateEmailTemplate />}
									/>
								</Route>
								<Route path={URL.helpManagement} element={<Outlet />}>
									<Route index element={<HelpQueriesRestaurants />} />
									<Route
										path={URL.helpQueriesRestaurants}
										element={<HelpQueriesRestaurants />}
									/>
									<Route
										path={URL.helpQueriesUsers}
										element={<HelpQueriesUsers />}
									/>
									<Route path={URL.helpTopics} element={<HelpTopics />} />
								</Route>
								<Route path={URL.faqsManagement} element={<Outlet />}>
									<Route index element={<FAQs />} />
									<Route path={URL.FAQs} element={<FAQs />}>
										<Route path={URL.faqsRestaurant} element={<FAQs />} />
										<Route path={URL.faqsUser} element={<FAQs />} />
									</Route>
									<Route
										path={URL.faqCategoryListing}
										element={<FaqCategoryListing />}
									>
										<Route
											path={URL.faqCategoryListingRestaurant}
											element={<FaqCategoryListing />}
										/>
										<Route
											path={URL.faqCategoryListingUser}
											element={<FaqCategoryListing />}
										/>
									</Route>
								</Route>
								<Route path={URL.masterManagement} element={<Outlet />}>
									<Route index element={<Categories />} />
									<Route path={URL.categories} element={<Categories />} />
									<Route path={URL.cuisines} element={<Cuisines />} />
									<Route path={URL.coupons} element={<Coupons />} />
									<Route path={URL.moods} element={<Moods />} />
								</Route>
								{/* <Route
									path={URL.paymentGatewaySettings}
									element={<PaymentGatewaySettings />}
								/> */}
								<Route path={URL.settings} element={<Outlet />}>
									<Route index element={<GeneralSettings />} />
									<Route
										path={URL.generalSettings}
										element={<GeneralSettings />}
									/>
									<Route
										path={URL.contactSettings}
										element={<ContactSettings />}
									/>
								</Route>
								<Route path={URL.promotions} element={<Outlet />}>
									<Route index element={<Promotions />} />
									<Route
										path={URL.addPromotions}
										element={<CreatePromotion />}
									/>
									<Route
										path={URL.promotionDetails}
										element={<SendPromotion />}
									/>
								</Route>
							</Route>
							<Route
								path={URL.login}
								element={
									isAuthenticated() ? (
										<Navigate to={URL.dashboard} />
									) : (
										<Login />
									)
								}
							/>
							<Route
								path={URL.resetPassword}
								element={
									isAuthenticated() ? (
										<Navigate to={URL.dashboard} />
									) : (
										<ResetPassword />
									)
								}
							/>
							<Route
								path={URL.forgotPassword}
								element={
									isAuthenticated() ? (
										<Navigate to={URL.dashboard} />
									) : (
										<ForgotPassword />
									)
								}
							/>
							<Route path="/*" component={PageNotFound} />
						</Routes>
					</BrowserRouter>
					<FullPageLoader loading={false} />
				</PersistGate>
			</Provider>
		</div>
	);
}

export default App;
